import { useEffect, useRef } from 'react';
import * as DropdownMenu from 'components/dropdown-menu';

const TableRowDropdownTrigger = () => {
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (ref.current) {
            const td = ref.current.closest('td');
            td?.classList.add('!py-0');
            ref.current.parentElement?.classList.add('!float-right');
        }
    }, []);

    return <DropdownMenu.EllipsisTrigger onClick={e => e.stopPropagation()} ref={ref} />;
};

export { TableRowDropdownTrigger };
